import { forwardRef } from 'react';
import { SnackbarContent, CustomContentProps, useSnackbar } from 'notistack';
import { IconClose } from '../Icon/Index';

interface CustomSnackbarProps extends CustomContentProps {}

const CustomSnackbar = forwardRef<HTMLDivElement, CustomSnackbarProps>(
  (props, ref) => {
    const { id, message, variant } = props;
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = () => {
      closeSnackbar(id);
    };

    return (
      <SnackbarContent ref={ref} role='alert'>
        <div className={`theme-snackbar theme-snackbar-${variant}`}>
          <span>{message}</span>
          <IconClose
            className='theme-snackbar-close-button'
            fill='#fff'
            onClick={handleDismiss}
          />
        </div>
      </SnackbarContent>
    );
  },
);

export default CustomSnackbar;
